import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import LoginBanner from "../assets/login-bg-11.jpg";
import Logo from "../assets/Broward-Partnerships-for-kids-logo.png";
import TextInput from "../components/common/ui/Inputs/TextInput.jsx";
import Button from "../components/common/ui/Button.jsx";
import forgotPasswordSchema from "../validation/forgotPasswordSchema.js";
import { authActions } from "../_store/auth.slice.js";
import { showToastNotification } from "../components/common/ui/NotificationModal/ToastNotication.js";

function ForgotPassword({ userType }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState();
  const [errorMessage, setErrorMessage] = useState({});
  const [submit, setSubmit] = useState(false);
  const forgotPasswordResponse = useSelector(
    (state) => state.auth.forgotPasswordResponse
  );

  // Response - Forgot Password
  // useEffect(() => {
  //   if (forgotPasswordResponse?.status !== undefined) {
  //     switch (forgotPasswordResponse?.status) {
  //       case 1:
  //         showToastNotification(
  //           "Reset password link sent successfully",
  //           "success"
  //         );
  //         setSubmit(false);
  //         handleReset();
  //         dispatch(authActions.clearForgotPasswordResponse());
  //         break;
  //       case 0:
  //         showToastNotification(forgotPasswordResponse?.message, "warning");
  //         setSubmit(false);
  //         break;
  //       default:
  //         showToastNotification("Something went wrong", "warning");
  //         setSubmit(false);
  //         break;
  //     }
  //   }
  // }, [forgotPasswordResponse]);

  // Forgot Password - submit function
  const handleSubmit = async (event) => {
    event.preventDefault();

    setErrorMessage({});
    setSubmit(true);
    const { error } = forgotPasswordSchema({ email });
    if (error?.details) {
      setSubmit(false);
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path[0]]: e?.message,
        }));
      });
      return;
    }

    dispatch(authActions?.forgotPassword({ email: email }))
      .then((result) => {
        setSubmit(false);
        if (result?.payload?.status === 1) {
          showToastNotification(result?.payload?.message, "success");
          handleReset();
          dispatch(authActions.clearForgotPasswordResponse());
          // history?.navigate("/Admin/Committee", {
          //   state: { committeeID: 0 },
          // });
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        showToastNotification("Failed to create committee", "error");
        setSubmit(false);
      });

    // .then((response) => {
    //   if (response?.status === 1) {
    //     showToastNotification(
    //       "Reset password link sent successfully",
    //       "success"
    //     );
    //   } else {
    //     showToastNotification(
    //       response?.message || "Something went wrong",
    //       "error"
    //     );
    //   }
    // })
    // .catch((error) => {
    //   console.error("Catch Error:", error);
    //   showToastNotification(
    //     error?.message || "Server error occurred",
    //     "error"
    //   );
    // });
  };

  // Handle reset action
  const handleReset = () => {
    setErrorMessage({});
    setEmail("");
  };

  // Function for navigate login page
  const handleClickLogin = () => {
    if (userType === "admin") {
      navigate("/Admin/login");
    } else {
      navigate("/login");
    }
  };

  // Function for navigate regsiter page
  const handleSignUp = () => {
    navigate("/register");
  };

  return (
    <>
      <div className="register register-with-news-feed">
        {/* ----------------- Left Section --------------- */}
        <div className="news-feed">
          <div
            className="news-image"
            style={{
              backgroundImage: `url(${LoginBanner})`,
            }}
          ></div>

          <div className="news-caption">
            <h1 className="text-white font-xl">
              <b>BROWARD PARTNERSHIPS FOR KIDS</b>
            </h1>
            <p className="font-size-20 max-width-80">
              Send & Receive Secure Electronic Messages With Your{" "}
              <span className="default-color">Loved</span> Ones. There’s no
              better way to stay connected with your loved one or friend than
              real time messages.
            </p>
          </div>
        </div>
        {/* ----------------- Right Section --------------- */}
        <div className="register-container">
          <div className="login-header mb-20px">
            <div className="brand">
              <div
                className="d-flex align-items-center mt-4"
                style={{ justifyContent: "center" }}
              >
                <img
                  src={Logo}
                  className="company-logo"
                  alt="Broward Partnerships for Kids Logo"
                />
              </div>
            </div>
          </div>
          <div className="position-absolute top-0 end-0 p-4">
            <span className="text-dark fs-12 text-decoration-none">
              <span className="font-size-15">
                New User{" "}
                <b
                  className="txt-primary text-underline"
                  onClick={handleSignUp}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      handleSignUp();
                    }
                  }}
                  style={{ cursor: "pointer" }}
                  aria-label="Sign Up for a new account"
                >
                  Sign Up
                </b>
              </span>
            </span>
          </div>
          <div className="register-content">
            <form className="fs-13px" onSubmit={handleSubmit}>
              <h2 className="title-default mb-2">
                Forgot <span id="forgetTitle"> Password?</span>
              </h2>
              <p className="font-size-16">
                {/* Please enter the email you used to sign up for your BPK account.
                We will send a password reset link to the registered email. */}
                Enter the email you used to sign up for your BPK account. We'll
                send you a link to reset your password.
              </p>
              <div className="mb-3">
                <TextInput
                  name="email"
                  label="Email Address"
                  ariaLabel="Email Address"
                  value={email}
                  handleChange={(e) => {
                    setEmail(e?.target?.value);
                  }}
                  placeholder="Email Address"
                  required={true}
                  errorMessage={errorMessage}
                //    handleBlur={handleBlur}    // temporarly Commented
                />
              </div>
              <div className="mb-4">
                <Button
                  className={"me-2"}
                  label="Submit"
                  type="submit"
                  status="primary"
                  disabled={submit}
                />
                {/* <Button
                  className="me-2 "
                  label="Reset"
                  type="reset"
                  variant="danger"
                  status={"secondary"}
                  disabled={false}
                  onClick={handleReset}
                /> */}
                {/* Back to Login Text */}

                <span
                  className="font-size-15 d-block mt-3 mb-40px pb-40px " // Using Bootstrap's "danger" color
                >
                  Back to{" "}
                  <b
                    className="txt-primary text-underline font-size-15"
                    onClick={handleClickLogin}
                    style={{ cursor: "pointer" }}
                  >
                    {" "}
                    Login
                  </b>
                </span>
              </div>
              <hr className="bg-gray-600 opacity-2 " />
              <p className="text-center text-gray-600">
                &copy; BPK All Right Reserved {new Date().getFullYear()}
              </p>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default ForgotPassword;
